import { render, staticRenderFns } from "./warehouse-form.vue?vue&type=template&id=c81deb7c&scoped=true"
import script from "./warehouse-form.vue?vue&type=script&setup=true&lang=js"
export * from "./warehouse-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81deb7c",
  null
  
)

export default component.exports